// extracted by mini-css-extract-plugin
module.exports = {"flink":"Footer_flink__3c1Ba","cfooter":"Footer_cfooter__1LIlZ"};